<template>
  <div class="error-page">
    <div class="container">
      <div class="error-content">
        <h1 class="error-code">{{ error.statusCode }}</h1>
        <h2 class="error-title">{{ errorTitle }}</h2>
        <p class="error-message">{{ errorMessage }}</p>
        <div class="error-actions">
          <NuxtLink to="/" class="btn btn-primary">返回首页</NuxtLink>
          <button @click="handleRetry" class="btn btn-outline">重试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { clearError } from '#app'

const props = defineProps({
  error: {
    type: Object,
    required: true
  }
})

const errorTitle = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return '页面未找到'
    case 500:
      return '服务器错误'
    default:
      return '发生错误'
  }
})

const errorMessage = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return '抱歉，您访问的页面不存在。'
    case 500:
      return '服务器遇到错误，请稍后重试。'
    default:
      return '发生未知错误，请重试或联系管理员。'
  }
})

const handleRetry = () => {
  clearError({ redirect: '/' })
}
</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $light-color;
}

.error-content {
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
}

.error-code {
  font-size: 8rem;
  font-weight: bold;
  color: $primary-color;
  margin-bottom: 1rem;
  line-height: 1;
}

.error-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: $dark-color;
}

.error-message {
  font-size: 1.125rem;
  color: $secondary-color;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 0.75rem 2rem;
  border-radius: 0.375rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
  border: none;
  cursor: pointer;
  
  &.btn-primary {
    background: $primary-color;
    color: #fff;
    
    &:hover {
      background: color.adjust($primary-color, $lightness: -10%);
    }
  }
  
  &.btn-outline {
    border: 2px solid $primary-color;
    color: $primary-color;
    background: transparent;
    
    &:hover {
      background: $primary-color;
      color: #fff;
    }
  }
}

@media (max-width: 768px) {
  .error-code {
    font-size: 6rem;
  }
  
  .error-title {
    font-size: 2rem;
  }
  
  .error-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 100%;
    max-width: 200px;
  }
}
</style>